<template>
    <modal name="document-select-modal"
        :adaptive="true"
        :focusTrap="true"
        :width="600"
        height="auto"
        :scrollable="true"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        @before-close="beforeClose"
    >
        <div class="rounded-lg bg-white p-6">
            <div class="text-md mb-2">
                <i class="fa fa-list-alt mr-1 text-gray-500" />
                Document Library
            </div>

            <p class="text-base text-gray-500 mb-4 leading-snug">
                Select one or more documents from your Document Library
            </p>

            <div class="border border-gray-300 bg-gray-warm-50 px-4 py-2 overflow-y-auto my-3"
                style="maxHeight: 400px;"
            >
                <div v-for="folder in folders_with_documents"
                    class="mb-3 pt-2"
                >
                    <div class="flex items-center justify-between">
                        <div class="flex items-start leading-tight text-base text-gray-500">
                            <folder-icon size="16"
                                class="flex-none mr-2 text-gray-300"
                                :stroke-width="2"
                                fill="#d1d5db"
                            />

                            {{ folder.name }}
                        </div>
                    </div>

                    <div v-for="document in folder.documents">
                        <div class="pl-6 pt-1.5"
                            :class="selected.includes(document.id) ? 'text-blue-500' : 'hover:text-blue-500'"
                            @click="toggleSelection(document.id)"
                        >
                            <div class="flex items-start">
                                <input
                                    type="checkbox"
                                    :name="'selected_' + document.id"
                                    v-model="selected"
                                    :value="document.id"
                                    class="w-4 h-4 mt-1"
                                    @click.stop
                                />

                                <div class="font-semibold text-md leading-snug select-none pl-3 pt-px">
                                    {{ document.display_filename }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-end pt-4">
                <button type="button"
                    class="flex-none uppercase tracking-widest border-green-warm-600 bg-green-warm-600 hover:bg-green-warm-500 text-white text-sm hover:text-white px-10 py-2"
                    @click="done"
                >
                    Done
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { FolderIcon } from 'vue-feather-icons';

export default {
    components: {
        FolderIcon,
    },

    props: {
        show: {},
        documents: {},
        folders: {},
        selected_ids: { default: () => [] },
    },

    computed: {
        folders_with_documents() {
            return this.folders.map(folder => {
                folder.documents = this.getDocumentsForFolder(folder);

                return folder;
            }).filter(folder => folder.documents.length);
        },
    },

    data() {
        return {
            selected: [],
        }
    },

    methods: {
        beforeOpen() {
            this.selected = [...this.selected_ids];
        },
        beforeClose(event) {
            this.$emit('closed');
        },
        getDocumentsForFolder(folder) {
            return this.documents.filter(document => document.folder_id === folder.id);
        },
        done() {
            this.$emit('selected', this.selected);
            this.$modal.hide('document-select-modal');
        },
        toggleSelection(document_id) {
            const index = this.selected.findIndex(selection => selection === document_id);

            if (index > -1) {
                this.selected.splice(index, 1);
            } else {
                this.selected.push(document_id);
            }
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.beforeOpen();
                this.$modal.show('document-select-modal');
            } else {
                this.$modal.hide('document-select-modal');
            }
        },
    },
}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
